// extracted by mini-css-extract-plugin
module.exports = {"ImageGalleryItem":"ImageGalleryItem_ImageGalleryItem__3CvRl","ImageGalleryItem-image":"ImageGalleryItem_ImageGalleryItem-image__1C-z-"};